import {Component, Input, OnInit} from '@angular/core';
import ArrayStore from 'devextreme/data/array_store';

@Component({
  selector: 'app-usage-optimization',
  templateUrl: './usage-optimization.component.html',
  styleUrls: ['./usage-optimization.component.scss']
})
export class UsageOptimizationComponent implements OnInit {
  @Input()
  index: any;

  @Input()
  store: ArrayStore;

  constructor() { }

  ngOnInit(): void {
  }

}
